import { AxiosError } from 'axios'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { apiService, notificationService } from '../services'
import { setSelectedUser } from '../store/reducers/userReducer'
import { t } from 'i18next'
import { useNavigate } from 'react-router-dom'
import { urlList } from '../constants/urlConstant'

const baseUrl = urlList.USERS

interface UseUserDetailsProps {
  userId?: string
}

const useUserDetails = ({ userId }: UseUserDetailsProps) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [error, setError] = useState<AxiosError | Error>()

  const refreshUser = useCallback(async () => {
    if (!userId) return

    try {
      const response = await apiService.fetchItems(`${baseUrl}/${userId}`)
      dispatch(setSelectedUser(response))
    } catch (error) {
      console.error('Failed to fetch user', error)
      setError(error as AxiosError | Error)
    }
  }, [dispatch, userId])

  useEffect(() => {
    refreshUser()
  }, [refreshUser])

  const patchUser = useCallback(
    async (
      url: string,
      param: any,
      setSaveLoading: (value: boolean) => void,
      successMessage?: string,
      errorMessage?: string
    ) => {
      setSaveLoading(true)
      try {
        await apiService.patchItem(url, navigate, param)
        notificationService.notificationSuccess({
          messageToDisplay: successMessage || '',
        })
        await refreshUser()
      } catch (error) {
        console.error('Update error', error)
        notificationService.notificationError({
          messageToDisplay:
            t(errorMessage ? errorMessage : 'userDetailsPage.saveUserError') ||
            '',
        })
        setError(error as AxiosError | Error)
      } finally {
        setSaveLoading(false)
      }
    },
    [refreshUser, navigate]
  )

  return {
    refreshUser,
    patchUser,
    error,
  }
}

export default useUserDetails
